import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { RoutesEnum } from 'src/app/enums/routes-enum';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
})
export class SigninComponent implements OnInit {
  client: string = '';
  link: string = '';
  signinForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]), // Ajout de Validators
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
    ]),
  });
  credentials: { email: string; password: string } | undefined;

  constructor(
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
  ) {}
  ngOnInit(): void {
    this.client = this.router.url.split('/')?.[1];

    this.link = '/' + this.client + '/signup';
  }

  /*login() {
    this.credentials = this.signinForm.value as {
      email: string;
      password: string;
    };
    this.authService.login(this.credentials, this.client).subscribe(
      (_re) => {
        this.client ==='company'? this.router.navigate([this.client + '/titre-restaurant']): 
        this.router.navigate([this.client + '/transactions']);
      },
      (_error) => {
        this.show();
      }
    );
  }*/
  login() {
    this.credentials = this.signinForm.value as {
      email: string;
      password: string;
    };

    this.authService.login(this.credentials, this.client).subscribe(
      (res) => {
        this.authService.setMustChangePassword(res.result.mustChangePassword);
       // console.log('mustChangePassword →', res.result.mustChangePassword);
        // Vérifie le flag
        if (res.result.mustChangePassword) {
          // Redirection vers la page de changement de mot de passe (company ou merchant)
          this.router
            .navigate([`/${this.client}/change-password`])
            .then((success) => {
             // console.log('Navigation réussie ?', success);
            });
        } else {
          // Redirection normale après login
          this.client === 'company'
            ? this.router.navigate([this.client + '/titre-restaurant'])
            : this.router.navigate([this.client + '/transactions']);
        }
      },
      (_error) => {
        this.show();
      },
    );
  }

  show() {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: "l'email ou le mot de passe est incorrect!",
    });
  }
}
